import styled from 'styled-components';

export const LimitedFeatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 2px;

  .limited-feature-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
      display: block;
    }
  }
`;
